import GenericApi from "../../../../services/generics";
import Config from "../../../../config";

const getAllPricingPackages = async () => {
  const output = [];
  try {
    let response = await GenericApi.getPricingPackages({ showNew: false });
    if (!response.success && !Array.isArray(response.body)) {
      throw new Error("Could not able to get pricin,g packages");
    }
    output.push(...response.body);
    response = await GenericApi.getPricingPackages({ showNew: true });
    if (!response.success && !Array.isArray(response.body)) {
      throw new Error("Could not able to get pricing packages");
    }
    const { PRICING_TIERS_ORDER } = Config;
    output.push(...response.body);
    if (Array.isArray(PRICING_TIERS_ORDER)) {
      output.sort(
        (element1, element2) =>
          PRICING_TIERS_ORDER.indexOf(element1) -
          PRICING_TIERS_ORDER.indexOf(element2)
      );
    }
  } catch (error) {
    // TODO: Error Handling
    throw error;
  }
  return output;
};

const Domain = {
  getAllPricingPackages,
};

export default Domain;
